import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiStrutturaliL1SectionWrapper,
  InspectionInfoForm,
} from 'components';
import {
  CDAOptions,
  tipoElementoAggiuntivoCollegamentiOptions,
  tipologiaElementoExtraOptions,
} from 'constants/selectOptions';
import useTabellaRiepilogativa from 'hooks/inspections/useTabellaRiepilogativa';
import { INFO } from 'pages/Inspections/config/info';
import { calculateDifettositaComplessiva } from 'pages/Inspections/CreateInspection/utils/extractDefectivenessInfo';
import ElementiAggiuntiviForm from './ElementiAggiuntiviForm';

const ElementiAggiuntiviSection = ({ selectedIdx }) => {
  const { recalculateTable } = useTabellaRiepilogativa();
  const { watch, setValue, getValues } = useFormContext();

  const spallePileCollegamentiTableExtraTableWatch = watch(
    `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`
  );

  // Ispezioni v1: il bucket non esiste nel dato (introdotto da task 11), quindi
  // risulta undefined invece di [] - l'UI mostra il messaggio "Nessun/a elemento
  // aggiuntivo presente" solo quando la tabella è esplicitamente un array vuoto.
  useEffect(() => {
    if (
      selectedIdx !== undefined &&
      selectedIdx !== '' &&
      spallePileCollegamentiTableExtraTableWatch === undefined
    ) {
      setValue(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`,
        []
      );
    }
  }, [selectedIdx, spallePileCollegamentiTableExtraTableWatch]);

  const spallePileCollegamentiTable = watch(`spallePileCollegamentiTable`);

  const spallePileToCopy = spallePileCollegamentiTable?.map(
    el => el.elementiAggiuntiviTable || []
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsElementiExtra = item => {
    setValue('elementiAggiuntiviTable', [item]);
    setValue('tipoElementoAggiuntivoTableValue', item.tipoElementoExtra);
    setValue(
      'tipologiaElementoAggiuntivoTableValue',
      item.tipologiaElementoExtra
    );
  };

  const handleSelectAllClickElementiExtra = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`
      );
      setSelected(selectedValue);
      setValue('elementiAggiuntiviTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('elementiAggiuntiviTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t2a6_tecnicoRilevatoreElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t2a6_dataIspezioneElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t2a6_elementoCriticoStrutturaElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].elementoCriticoStruttura`
      ) || ''
    );
    setValue(
      'l1t2a6_elementoCriticoSismicaElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].elementoCriticoSismica`
      ) || ''
    );
    setValue(
      'l1t2a6_condizioneCriticaStrutturaElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].condizioneCriticaStruttura`
      ) || ''
    );
    setValue(
      'l1t2a6_condizioneCriticaSismicaElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].condizioneCriticaSismica`
      ) || ''
    );
    setValue(
      'l1t2a6_noteGeneraliElementiAggiuntivi',
      getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues(
      'l1t2a6_tecnicoRilevatoreElementiAggiuntivi'
    );
    const dataIspezione = getValues('l1t2a6_dataIspezioneElementiAggiuntivi');
    const elementoCriticoStruttura = getValues(
      'l1t2a6_elementoCriticoStrutturaElementiAggiuntivi'
    );
    const elementoCriticoSismica = getValues(
      'l1t2a6_elementoCriticoSismicaElementiAggiuntivi'
    );
    const condizioneCriticaStruttura = getValues(
      'l1t2a6_condizioneCriticaStrutturaElementiAggiuntivi'
    );
    const condizioneCriticaSismica = getValues(
      'l1t2a6_condizioneCriticaSismicaElementiAggiuntivi'
    );
    const noteGenerali = getValues('l1t2a6_noteGeneraliElementiAggiuntivi');
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].elementoCriticoStruttura`,
      elementoCriticoStruttura
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].elementoCriticoSismica`,
      elementoCriticoSismica
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].condizioneCriticaStruttura`,
      condizioneCriticaStruttura
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].condizioneCriticaSismica`,
      condizioneCriticaSismica
    );
    setValue(
      `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
    setValue('l1t2a6_trigger', Math.random() * 1000);
    setTimeout(() => {
      recalculateTable();
    }, 0);

    // Gestione calcolo difettosità complessiva nella tabella riepilogativa
    const tableWatch = getValues('riepilogoStrutturaTable');
    const difettositaStrutturaleEffettiva = watch(
      'arbitraryStructuralFoundationalDefectiveness'
    );
    const difettositaSismicaEffettiva = watch('arbitrarySeismicDefectiveness');
    const tabellaRiepilogativa = tableWatch.filter(
      row => row.codice !== 'Difettosità complessiva'
    );
    const { difettositaStrutturale, difettositaSismica } =
      calculateDifettositaComplessiva(tabellaRiepilogativa);
    const updatedTable = tableWatch.map(row => {
      if (row.codice === 'Difettosità complessiva') {
        return {
          ...row,
          difettositaStrutturale,
          difettositaSismica,
        };
      }
      return row;
    });
    setValue('riepilogoStrutturaTable', updatedTable);
    !difettositaStrutturaleEffettiva &&
      setValue(
        'arbitraryStructuralFoundationalDefectiveness',
        difettositaStrutturale
      );
    !difettositaSismicaEffettiva &&
      setValue('arbitrarySeismicDefectiveness', difettositaSismica);
  };

  const handleResetInspection = () => {
    setValue(`l1t2a6_tecnicoRilevatoreElementiAggiuntivi`, '');
    setValue(`l1t2a6_dataIspezioneElementiAggiuntivi`, null);
    setValue(`l1t2a6_elementoCriticoStrutturaElementiAggiuntivi`, '');
    setValue(`l1t2a6_elementoCriticoSismicaElementiAggiuntivi`, '');
    setValue(`l1t2a6_condizioneCriticaStrutturaElementiAggiuntivi`, '');
    setValue(`l1t2a6_condizioneCriticaSismicaElementiAggiuntivi`, '');
    setValue(`l1t2a6_noteGeneraliElementiAggiuntivi`, '');
  };

  const dataElementiExtraConfig = {
    columns: {
      codice: { label: 'Cod.' },
      tipoElementoExtra: {
        label: 'Tipo Elemento',
        format: tipoElementoAggiuntivoCollegamentiOptions,
      },
      tipologiaElementoExtra: {
        label: 'Tipologia',
        format: tipologiaElementoExtraOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      indiceCondizione: { label: 'Indice di condizione' },
      CDAstrutturale: { label: 'Difettosità Str.', format: CDAOptions },
      CDAsismica: { label: 'Difettosità Sis.', format: CDAOptions },
      nrtotali: { label: 'NR' },
      g5totali: { label: 'G=5' },
      pstotali: { label: 'PS' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipoElementoExtra: {
        label: 'Tipo Elemento',
        format: tipoElementoAggiuntivoCollegamentiOptions,
      },
      tipologiaElementoExtra: {
        label: 'Tipologia',
        format: tipologiaElementoExtraOptions,
      },
    },
  };

  const spallePileCollegamentoSelezione = watch(
    'spallePileCollegamentoSelezione'
  );

  useEffect(() => {
    if (spallePileCollegamentoSelezione) {
      setSchedaDifettiIndex(undefined);
      setOpenSchedaDifetti(false);
    }
  }, [spallePileCollegamentoSelezione]);

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiStrutturaliL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'elementi aggiuntivi'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoElementiExtra.drawerTitle}
        drawerText={INFO.impalcatoElementiExtra.drawerText}
        singleElementTitle={'elemento aggiuntivo'}
        tableWatch={spallePileCollegamentiTableExtraTableWatch}
        tableWatchName={`spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`}
        elementForm={
          <ElementiAggiuntiviForm
            elementiExtraFields={
              spallePileCollegamentiTableExtraTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            elementiExtraTable={`spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoForm
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t2a6_tecnicoRilevatoreElementiAggiuntivi'}
            dateName={'l1t2a6_dataIspezioneElementiAggiuntivi'}
            elementoCriticoStrutturaName={
              'l1t2a6_elementoCriticoStrutturaElementiAggiuntivi'
            }
            elementoCriticoSismicaName={
              'l1t2a6_elementoCriticoSismicaElementiAggiuntivi'
            }
            condizioneCriticaStrutturaName={
              'l1t2a6_condizioneCriticaStrutturaElementiAggiuntivi'
            }
            condizioneCriticaSismicaName={
              'l1t2a6_condizioneCriticaSismicaElementiAggiuntivi'
            }
            noteGeneraliName={'l1t2a6_noteGeneraliElementiAggiuntivi'}
          />
        }
        tableConfig={dataElementiExtraConfig}
        editRows={editRowsElementiExtra}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickElementiExtra}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={['tipoElementoExtra', 'tipologiaElementoExtra']}
        tableForCopy={spallePileToCopy}
        elementTypeField="tipoElementoExtra"
        elementTypeOptions={tipoElementoAggiuntivoCollegamentiOptions}
      />
    </>
  );
};
ElementiAggiuntiviSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ElementiAggiuntiviSection;
